import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';
import daniel from '../../assets/daniel-shapiro-dnXGJHBHdfg-unsplash.jpg';
import luca from '../../assets/rumman-amin-3cvpdPLZw9A-unsplash-copy.jpg';

import jairph from '../../assets/omar-bakri-5MtiChVjZGM-unsplash.jpg';
import gaddafi from '../../assets/matthew-foulds-Bae7oqEB0d8-unsplash.jpg';
import img1 from '../../assets/kate-trysh-nX_IsIcF7ow-unsplash.webp';
import img2 from '../../assets/kate-trysh-SueCu7_G-oc-unsplash.webp';
import img3 from '../../assets/lifestyle-business-woman-feel-happy-jumping-air-celebrating-success.webp';
import img4 from '../../assets/maximus-beaumont-1odTkU58Xus-unsplash.webp';
import img5 from '../../assets/nejc-soklic-SbEhnhUu0nw-unsplash.webp';
import img6 from '../../assets/valeria-andersson-0IGhARplNzY-unsplash.webp';
import img7 from '../../assets/young-woman-take-photos-singapore.webp';
import { img } from 'framer-motion/client';
export default function Hero(){
  const images = [
    img5,
    
    // jairph,
  //  luca,
  //   gaddafi,
    img6,
    img1,
    img7,
    daniel,
    img2,
    img3,
    img4,
    
  ];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, 4000);
    return () => clearInterval(id);
  }, [images.length]);
  return (
    <section className="relative overflow-hidden h-[80vh] md:h-[80vh]">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="relative h-full w-full">
          {images.map((src, i) => (
            <img
              key={i}
              src={src}
              alt="hero"
              fetchpriority={i === 0 ? 'high' : undefined}
              className="absolute inset-0 w-full h-[90vh] md:h-[90vh] object-cover"
              style={{ transform: `translateX(${(i - index) * 100}%)`, transition: 'transform 700ms cubic-bezier(0.22,1,0.36,1)' }}
            />
          ))}
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/10"/>
      </div>
      <div className="container h-full flex flex-col items-center justify-center py-16 md:py-24 text-center">
        <motion.h1 initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{duration:.6}} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white drop-shadow-sm">
          <span className="text-primary">Discover</span>. Explore. Go!
        </motion.h1>
        <motion.p initial={{opacity:0}} whileInView={{opacity:1}} transition={{delay:.2}} className="mt-4 text-white/90 max-w-2xl md:max-w-3xl mx-auto">
          From visas and flights to hotels and curated tour packages, we make travel effortless with transparent pricing and 24×7 support. Discover inspiring destinations and craft unforgettable experiences.
        </motion.p>
        <motion.div initial={{opacity:0, y:10}} whileInView={{opacity:1, y:0}} transition={{delay:.35}} className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/services" className="btn-primary rounded-full px-6 h-11 inline-flex items-center gap-2 shadow-md shadow-primary/30 hover:shadow-lg hover:-translate-y-0.5 transition">
            <span>Explore Services</span>
          </Link>
          <Link to="/contact" className="btn-outline rounded-full px-6 h-11 inline-flex items-center gap-2 border-white/60 text-white hover:bg-white/10">
            <span>Contact Us</span>
          </Link>
        </motion.div>
        <div className="absolute bottom-6 left-0 right-0 flex items-center justify-center gap-2">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Go to slide ${i+1}`}
              className={`h-2.5 w-2.5 rounded-full transition ${i===index? 'bg-white':'bg-white/50 hover:bg-white/80'}`}
            />
          ))}
        </div>
        {/* <SearchBar /> */}
      </div>
    </section>
  );
}
